import React from "react";

const Backtest: React.FC = () => {
  return (
    <div className="p-4">
      <h4>Backtest</h4>
      <p>Backtest functionality coming soon...</p>
    </div>
  );
};

export default Backtest;
